import * as Sentry from "@sentry/browser";

// Initialize Sentry
Sentry.init({
  dsn: "https://824c001b6b636e7385ce05bd6d6359df@o4508937207742464.ingest.de.sentry.io/4508937249947728",
  release: "tshmanager@1.0.0",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/app.tshmanager\.hu/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Add user data to Sentry
export async function setupSentryUser() {
  try {
    const response = await fetch(`/userinfo`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    });
    
    if (response.status === 200) {
      const data = await response.json();
      Sentry.setUser({
        name: data.name,
        email: data.email,
      });
    }
  } catch (error) {
    console.error('Error occurred while loading user data:', error);
  }
}

// Setup Sentry with user data
setupSentryUser(); 